<template>
<div>
  <b-form @submit.prevent="resetPassword" v-if="!passwordChanged">
    <b-form-group label-cols-sm="4" label="Password" label-for="password">
      <b-form-input id="password" v-model="password" type="password" required :state="passwordState"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="4" label="Confirm password" label-for="confirm-password">
      <b-form-input id="confirm-password" v-model="confirmPassword" type="password" required :state="passwordState"></b-form-input>
      <b-form-invalid-feedback>{{errorMsg}}</b-form-invalid-feedback>
    </b-form-group>
    <div class="form-footer">
      <b-button variant="primary" type="submit" :disabled="loading" class="float-right">
        Reset password
        <b-spinner small v-if="loading"></b-spinner>
        <span class="sr-only" v-if="loading">Loading...</span>
      </b-button>
    </div>
  </b-form>
  <strong v-if="passwordChanged" class="text-center">Your password has been successfully reset</strong>
</div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      password: null,
      confirmPassword: null,
      errorMsg: null
    };
  },
  computed: {
    passwordState() {
      if (this.errorMsg) {
        return false;
      }
      return null;
    },
    loading() { return this.$store.state.resetPasswordLoading; },
    passwordChanged() { return this.$store.state.passwordChanged; }
  },
  methods: {
    resetPassword() {
      this.errorMsg = null;
      if (this.password !== this.confirmPassword) {
        this.errorMsg = "Passwords don't match!";
        return;
      }
      this.$store.dispatch('resetPassword', this.password);
    }
  }
}
</script>
